import { Checkbox, UIText2, useDeviceType } from '@cian/ui-kit';
import { Link } from '../Link';
import { ChangeEvent } from 'react';
import { clsx } from 'clsx';

import * as styles from './DobroFormSign.css';

export interface IDobroFormSignProps {
  offerDocumentUrl: string;
  politicsDocumentUrl: string;
  checked: boolean;
  invalid: boolean;
  onChange: (event: ChangeEvent<HTMLInputElement>, checked: boolean) => void;
  onOfferDocumentClick: (e: React.MouseEvent<HTMLElement>) => void;
  onPoliticsDocumentClick: (e: React.MouseEvent<HTMLElement>) => void;
}

export function DobroFormSign(props: IDobroFormSignProps) {
  const deviceType = useDeviceType();

  return (
    <label
      className={clsx(styles.label, {
        [styles.desktop]: deviceType === 'desktop',
      })}
    >
      <UIText2>
        <Link href={props.offerDocumentUrl} onClick={props.onOfferDocumentClick}>
          Соглашаюсь
        </Link>{' '}
        на&nbsp;обработку персональных данных в&nbsp;соответствии с&nbsp;
        <Link href={props.politicsDocumentUrl} onClick={props.onPoliticsDocumentClick}>
          Политикой конфиденциальности
        </Link>
      </UIText2>
      <span className={styles.checkbox}>
        <Checkbox checked={props.checked} onChange={props.onChange} invalid={props.invalid} />
      </span>
    </label>
  );
}
